import { all, fork, put, takeEvery, call, delay } from "redux-saga/effects"
import * as actionTypes from "appRedux/actions/addon/AddonActionType"
import * as actionCreators from "appRedux/actions/addon/Addon"
import { userSignOut } from "appRedux/actions/Auth"
import { API_URL_V1, API_PMS_HEADERS } from "constants/ApiSetting"
import { getItems } from "util/localStorage"
import { APIGetRequest } from "util/connection"
import { ApiResponse } from "constants/ActionTypes"
import { Modal } from "antd"

function* exportParamsProcess({ payload }: actionTypes.ExportParamsRequest): Generator<any, void, any> {
  try {
    const { access_token } = yield call(getItems, ['access_token'])
    const AccessToken = access_token
    const url = `${API_URL_V1}pms/dataExport/${payload.code}/getParams`
    API_PMS_HEADERS.headers.Authorization = `Bearer ${AccessToken}`
    
    // APIGetRequest returns response.data directly (not axios response object)
    // So response is: { data: { arrival: "2023-01-01" }, status: 200, message: "..." }
    const response: any = yield APIGetRequest(url, API_PMS_HEADERS)

    // Check if response has status property (from API response body)
    const responseStatus = response?.status;
    
    if (responseStatus === 200) {
      // Extract the nested data object: { data: { arrival: "2023-01-01" } } -> { arrival: "2023-01-01" }
      const paramsData = response?.data;
      
      if (paramsData) {
        yield put(actionCreators.exportParamsSuccess(paramsData, payload.code))
        yield delay(100)
      } else {
        yield put(actionCreators.exportParamsFailure("No data received from API", payload.code))
        yield delay(100)
      }
    } else {
      const message = response?.message || "Failed to fetch export params";
      const data = response?.data;
      
      yield put(actionCreators.exportParamsFailure(message, payload.code))
      yield delay(100)
      
      if (responseStatus === 401 || responseStatus === 403) {
        /* if status 401 (Unauthorized) or 403 (Forbidden) force signout */
        yield put(userSignOut())
      } else {
        // Show error modal for non-401/403 errors
        Modal.error({
          title: "Export Error",
          content: message,
        });
      }
    }
  } catch (error: any) {
    const errorMessage = error?.message || String(error)
    yield put(actionCreators.exportParamsFailure(errorMessage, payload.code))
    yield delay(100)
    Modal.error({
      title: "Request Failed",
      content: errorMessage,
    });
  }
}

function* exportParams() {
  yield takeEvery(actionTypes.EXPORT_PARAMS_REQUEST, exportParamsProcess)
}

export default function* rootSaga() {
  yield all([
    fork(exportParams)
  ])
}

